import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background: #f0f0f5;
    font-family: 'Ubuntu', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  button {
    cursor: pointer;
    outline: none;
  }

  a {
    text-decoration: none;
    color: #000;
    font-weight: 400;
    cursor: pointer;
  }

  p {
    font-weight: 400;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #322153;
  }
`;
